exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".map-caption {\n  position: absolute;\n  right: 20px;\n  bottom: 60px;\n  width: 74px;\n  z-index: 9999;\n  border-radius: 4px;\n  box-shadow: 0 0 6px 0 rgba(32,33,36,0.28);\n}\n.map-caption img {\n  width: 74px;\n}\n", ""]);

